export const safeShutdownIntercom = () => {
	if (typeof window === 'undefined' || typeof window.Intercom !== 'function') return false;

	try {
		window.Intercom('shutdown');
		return true;
	} catch (_) {
		return false;
	}
};
